module.exports = __webpack_public_path__ + "static/media/bed-moving-Icon-p-2.e2534b79.svg";